var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-alert',{attrs:{"value":true,"color":"success","icon":"check_circle","outline":""}},[_vm._v("\n          Correo electrónico verificado correctamente.\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a410bd9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/auth/verified.vue
// module id = oLm4
// module chunks = 2